;(function() {
    'use strict';

    angular
        .module('elogbooks.common.document-sets', []);
})();